import AbstractModelType from '../AbstractModelType';

/**
 * Represents a OS + browser instance that is used to view the reader.
 * e.g. "Firefox on Linux"
 *
 * Also includes "nth of type" to differentiate multiple unique devices that have the same description.
 * e.g. "Firefox on Linux" for an Ubuntu laptop used to create an offline session in the book for the first time,
 * and "Firefox on Linux 2" for a desktop running Arch used to create a second offline session.
 */
class Device extends AbstractModelType {
  #uuid;
  #description;
  #nthOfKind;

  constructor(properties) {
    super(...arguments);

    this.#uuid = properties.uuid ?? properties.deviceUuid; // it should just be "uuid" but backend uses deviceUuid
    this.#description = properties.description ?? '';
    this.#nthOfKind = parseInt(properties.nthOfKind ?? 1);
  }

  get uuid() {
    return this.#uuid;
  }

  get description() {
    return this.#description;
  }

  get nthOfKind() {
    return this.#nthOfKind;
  }
}

export default Device;
